import _isUndefined from 'lodash/isUndefined';

export default function allCardsAreRevealed(cardValues: Array<number | undefined>): cardValues is Array<number> {
  return !cardValues.some(_isUndefined);
}
